import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-uploaded-file',
  standalone: true,
  imports: [TranslocoPipe, CommonModule],
  templateUrl: './uploaded-file.component.html',
  styleUrl: './uploaded-file.component.css'
})
export class UploadedFileComponent {
  @Input() fileSrc: string = '';
  @Input() fileName: string = 'Unknown.file';
  @Input() fileSize: string = '... MB';
  @Input() currentValue: number = 0;
  @Input() canceled: boolean = false;

  @Output() stopClick = new EventEmitter<void>();

  onStopClick() {
    this.stopClick.emit();
  }
}
